import { Rpc } from '../rpc';
import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcDialogOverlayData, RpcOverlayOpenKey } from './rpc-overlay-model';

export class RpcOverlayOpenClient {
    /**
     * The overlay open command.
     *
     * @param data the dialog overlay object.
     * @return Promise<void> the promise object.
     */
    public static overlayOpen(rpc: Rpc, data: RpcDialogOverlayData): Promise<void> {
        return RpcInboundClient.call(rpc, RpcOverlayOpenKey.command, RpcOverlayOpenKey.version, data);
    }
}
